import {deleteBlogById, fetchAllBlogs, fetchBlogById, saveBlog} from "@/api/blog.api";
import Vue from "vue";


const state = {
    blogs: [],
    blogsPageInfo: {
        currentPage: 0,
        pageSize: 5
    }
}

const getters = {
    getBlogs: state => state.blogs,

    getBlogById: state => blogId => state.blogs.find(b => b.id === blogId)
}

const actions = {
    async deleteBlogById({ dispatch, state }, existingId) {
        await deleteBlogById(existingId)
        dispatch('pageBlogs', { page: state.blogsPageInfo.currentPage, pageSize: state.blogsPageInfo.pageSize })
    },

    async saveBlog({dispatch, state}, request){
        await saveBlog(request)
            .then(() => {
                Vue.notify({
                    group: 'success',
                    text: 'Blog je uspesno sacuvan'
                })
                dispatch('pageBlogs', { page: state.blogsPageInfo.currentPage, pageSize: state.blogsPageInfo.pageSize })
            })
            .catch(() => {
                Vue.notify({
                    group: 'errors',
                    title: 'Greška na serveru',
                    text: 'Doslo je do greske na serveru, molimo vas pokusajte kasnije'
                })
            })
    },

    async pageBlogs({ commit }, { page, pageSize }) {
        const response = await fetchAllBlogs(page, pageSize)
        const blogs = response.data.content
        commit('setBlogs', blogs)
        commit('setBlogsPageInfo', {
            currentPage: response.data.number,
            totalPages: response.data.totalPages,
            numberOfElements: response.data.numberOfElements,
            totalElements: response.data.totalElements,
            pageSize: response.data.size,
            isFirstPage: response.data.first,
            isLastPage: response.data.last
        })
    },

    async fetchBlogById({ commit }, id) {
        const response = await fetchBlogById(id)
        commit('updateBlog', response.data)
    },

}

const mutations = {
    updateBlog: (state, blog) => {
        state.blogs.push(blog)
    },

    setBlogs: (state, blogs) => {
        state.blogs = blogs
    },

    setBlogsPageInfo: (state, blogsPageInfo) => {
        state.blogsPageInfo = blogsPageInfo
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
